import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import dayjs from 'dayjs';
import { getStatusLabel } from '../../../util/paymentUtils';
import { getPaymentStatusIcon, getRefundStatusIcon } from './paymentStatusIcons';

function PaymentItem({ payment, getPaymentMethod }) {
  // Empty when the payment method is unknown — the row is left out then.
  const paymentMethodLabel = getPaymentMethod ? getPaymentMethod(payment) : '';

  return (
    <Paper sx={{ mb: 2, p: 2 }}>
      <Box sx={{ mb: 2 }}>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography variant='subtitle2'>
            Zahlung vom {dayjs(payment.startedAt).format('DD.MM.YYYY HH:mm')}
          </Typography>
          {getPaymentStatusIcon(payment.status)}
        </Box>
        <Box sx={{ pl: 2 }}>
          <Typography variant='body2'>
            <strong>Status:</strong> {getStatusLabel(payment.status)}
          </Typography>
          {paymentMethodLabel && (
            <Typography variant='body2'>
              <strong>Zahlungsart:</strong> {paymentMethodLabel}
            </Typography>
          )}
          <Typography variant='body2'>
            <strong>Betrag:</strong> {payment.amount?.toFixed(2).replace('.', ',')} €
          </Typography>
          {payment.authorizedAt && (
            <Typography variant='body2'>
              <strong>Autorisiert am:</strong>{' '}
              {dayjs(payment.authorizedAt).format('DD.MM.YYYY HH:mm')}
            </Typography>
          )}
          {payment.attemptCount > 1 && (
            <Typography variant='body2'>
              <strong>Anzahl Versuche:</strong> {payment.attemptCount}
            </Typography>
          )}
          {payment.buyerMail && (
            <Typography variant='body2'>
              <strong>Käufer E-Mail:</strong> {payment.buyerMail}
            </Typography>
          )}
        </Box>
      </Box>

      {payment.refunds?.length > 0 && (
        <Box sx={{ pl: 2, borderLeft: '2px solid #e0e0e0' }}>
          <Typography variant='subtitle2' gutterBottom>
            Erstattungen
          </Typography>
          {payment.refunds.map(refund => (
            <Paper
              key={refund.refundPspReference}
              sx={{ p: 2, mb: 1, bgcolor: 'rgba(0, 0, 0, 0.04)' }}
            >
              <Box display='flex' justifyContent='space-between' alignItems='center'>
                <Typography variant='body2'>
                  <strong>Datum:</strong> {dayjs(refund.date).format('DD.MM.YYYY HH:mm')}
                </Typography>
                {getRefundStatusIcon(refund.status)}
              </Box>
              <Typography variant='body2'>
                <strong>Status:</strong> {getStatusLabel(refund.status)}
              </Typography>
              <Typography variant='body2'>
                <strong>Betrag:</strong> -{refund.amount?.toFixed(2).replace('.', ',')} €
              </Typography>
              {refund.refundError && (
                <Typography variant='body2' color='error'>
                  <strong>Fehler:</strong> {refund.refundError}
                </Typography>
              )}
            </Paper>
          ))}
        </Box>
      )}
    </Paper>
  );
}

export default PaymentItem;
